import React from "react";

/**
 * ConfigurationLandscapeCanvas
 *
 * A stable visual coordinate system for the initial configuration.
 *
 * The analytical objects stay outside this component. This component only
 * provides drawing layers and a predictable spatial frame:
 *
 * substrate -> landscape -> routes -> capability -> callouts -> overlay
 *
 * viewBox coordinates deliberately remain stable even as the browser resizes.
 */
export default function ConfigurationLandscapeCanvas({
  className = "",
  ariaLabel = "Configuration landscape",
  substrate = null,
  landscape = null,
  routes = null,
  capability = null,
  callouts = null,
  overlay = null,
  footer = null,
}) {
  return (
    <section className={`rr-config-canvas-shell ${className}`.trim()}>
      <div className="rr-config-canvas-frame">
        <svg
          className="rr-config-canvas"
          viewBox="0 0 1000 760"
          preserveAspectRatio="xMidYMid meet"
          role="img"
          aria-label={ariaLabel}
        >
          <g className="rr-config-layer rr-config-layer-substrate">
            {substrate}
          </g>

          <g className="rr-config-layer rr-config-layer-landscape">
            {landscape}
          </g>

          <g className="rr-config-layer rr-config-layer-routes">
            {routes}
          </g>

          <g className="rr-config-layer rr-config-layer-capability">
            {capability}
          </g>

          <g className="rr-config-layer rr-config-layer-callouts">
            {callouts}
          </g>

          <g className="rr-config-layer rr-config-layer-overlay">
            {overlay}
          </g>
        </svg>

        {footer ? (
          <div className="rr-config-canvas-footer">
            {footer}
          </div>
        ) : null}
      </div>
    </section>
  );
}
